import {
  mdiTextBoxOutline,
  mdiHomeOutline,
  mdiProgressWrench,
  mdiTextBoxMultipleOutline,
  mdiNotebookRemove,
  mdiPokerChip,
  mdiShieldAccountOutline,
  mdiNoteText,
  mdiBallotOutline,
  mdiFileChartOutline,
  mdiAccountMultiple,
} from '@mdi/js'

export default [
  {
    subheader: 'Manufacturing',
  },
  // {
  //   title: 'Dashboard',
  //   icon: mdiDesktopMacDashboard,
  //   to: 'goals-dashboard',
  // },
  // {
  //   title: 'Master Bill Of Materials',
  //   icon: mdiFileDocumentOutline,
  //   to: 'mbom-list',
  // },
  {
    title: 'Work Center Overview',
    icon: mdiShieldAccountOutline,
    to: 'work-center-overview',
  },
  {
    title: 'Work Orders',
    icon: mdiPokerChip,
    to: 'manufacturing-work-orders',
  },
  {
    title: 'Group Manufacturing Order',
    icon: mdiProgressWrench,
    to: 'group-manufacturing-order',
  },
  {
    title: 'Manufacturing Order',
    icon: mdiProgressWrench,
    to: 'manufacturing-order',
  },
  {
    title: 'Quality Form',
    icon: mdiNoteText,
    to: 'manufacturing-quality-form',
  },
  {
    title: 'Void',
    icon: mdiNotebookRemove,
    to: 'manufacturing-void',
  },
  {
    title: 'Set Up',
    icon: mdiTextBoxMultipleOutline,
    children: [
      {
        title: 'Bill Of Materials',
        icon: mdiTextBoxOutline,
        to: 'bill-of-materials',
      },
      {
        title: 'Work Centers',
        icon: mdiHomeOutline,
        to: 'work-centers',
      },
    ],
  },

  {
    title: 'Project View',
    icon: mdiBallotOutline,
    to: 'manufacturing-project-view',
  },
  {
    title: 'Report',
    icon: mdiFileChartOutline,
    children: [
      {
        title: 'Manufacturing By Product',
        icon: mdiTextBoxOutline,
        to: 'manufacturing-report',
      },
      {
        title: 'Productivity Report',
        icon: mdiHomeOutline,
        to: 'workcenter-report',
      },
      {
        title: 'User Report',
        icon: mdiAccountMultiple,
        to: 'user-report',
      },
    ],
  },

  // {
  //   title: 'Bill Of Materials',
  //   icon: mdiTextBoxOutline,
  //   to: 'bill-of-materials',
  // },
  // {
  //   title: 'Routing',
  //   icon: mdiTextBoxOutline,
  //   to: 'manufacturing-routing',
  // },
  // {
  //   title: 'Work Centers',
  //   icon: mdiHomeOutline,
  //   to: 'work-centers',
  // },
  // {
  //   title: 'Planning',
  //   icon: mdiFloorPlan,
  //   to: 'manufacturing-planning',
  // },
]
